$(() => {
  const key = 'append-form-action-on-click';
  $(`[data-${key}]`).on('click', function () {
    this.closest('form').action += $(this).data(key);
  });
});
